import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import { css } from 'styled-components'

export const DRAWER_HEADER_GRID_AREA: string = 'drawer-header'
export const DRAWER_BODY_GRID_AREA: string = 'drawer-body'
export const DRAWER_FOOTER_GRID_AREA: string = 'drawer-footer'

export default css`
  @keyframes drawer-slide-right {
    from {
      transform: translateX(-100%);
    }

    to {
      transform: translateX(0);
    }
  }

  @keyframes drawer-slide-left {
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(-100%);
    }
  }

  .drawer {
    &__overlay {
      display: flex;
      max-height: calc(var(--vh, 1vh) * 100);
      overflow-y: unset !important;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    &__content {
      position: relative;
      overflow: hidden;

      background-color: ${props => props.theme.palette.neutral.eight};
      box-shadow: ${props => props.theme.shadow.top.medium};

      height: 100%;
      max-width: 100vw;
      width: 100%;

      animation-name:  drawer-slide-left;
      animation-iteration-count: 1;
      animation-duration: 300ms;
      animation-fill-mode: forwards;

      ${mediaQueryUp.sm} {
        max-width: ${rem(400)};
      }

      &.is-open {
        animation-name: drawer-slide-right;
      }
    }

    &__content,
    &__content > form {
      display: grid;
      grid-template-areas:
        '${DRAWER_HEADER_GRID_AREA}'
        '${DRAWER_BODY_GRID_AREA}'
        '${DRAWER_FOOTER_GRID_AREA}';
      grid-template-rows:
        [first]
        min-content
        1fr
        min-content
        [last];
      grid-template-columns: [first] 1fr [last];

      > .drawer-header {
        grid-area: ${DRAWER_HEADER_GRID_AREA};
      }

      > .drawer-body {
        grid-area: ${DRAWER_BODY_GRID_AREA};
      }

      > .drawer-footer {
        grid-area: ${DRAWER_FOOTER_GRID_AREA};
      }
    }

    &__content > form {
      /* stretch the form over the grid */
      grid-column: first/last;
      grid-row: first/last;
    }
  }
`
